import {
  PillarContent
} from '../models';

import {
  mapRelationships
} from './common-mapper';

export const mapPillarContent = (result) => {

  return result.data
    .map((item) => {
      return {
        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included, true),
          id: item.id
        }
      };
    })
    .map((content) => {
      return new PillarContent(content).mapToStandard();
    });
};
